const base = 'regional-costs';
const steps = {
  vehicleCosts: 'vehicle-costs',
  driverCosts: 'driver-costs',
  driverSalaryPeriods: 'driver-salary-periods'
};

export const RegionalCostsPath = {
  base,
  steps,
  vehicleCosts: `${base}/${steps.vehicleCosts}`,
  driverCosts: `${base}/${steps.driverCosts}`,
  driverSalaryPeriods: `${base}/${steps.driverSalaryPeriods}`
};
